// extracted by mini-css-extract-plugin
module.exports = {"root":"MediaFooter_root__XQ5Ma","title":"MediaFooter_title___V_B5","text":"MediaFooter_text__3VH7h","button":"MediaFooter_button__BjP_3"};